import { useEffect, useState, useRef } from 'react'
import { Col, Row, Overlay, Button, Popover } from 'react-bootstrap'
import { connect } from 'react-redux'
import { Formik, Form } from 'formik'
import { VzPageContainer } from '../../../layouts/VzPageContainer'
import FormikControl from '../../../layouts/Input/FormikControl'
import storage from '../../../apis/Storage'
import { GET_DISTRIBUTOR_DDL, GET_DISTRIBUTIONCENTER_DDL, GET_DELIVERYMAN_TILL_DDL,  GET_PAYMENT_TYPES_DDL } from '../../../Types'
import { formatDate } from '../../../utilities/FUNCTIONS'
import ServerSideDataTable from '../../../layouts/DataTables/ServerSideDataTable/ServerSideDataTable'
import { getDropdownList, getDropdownListByPost } from '../../Shared/dropdownListActions'
import { Link } from 'react-router-dom'
import { isPermittedPage } from '../../../apis/Utility'
import { renderCell,renderHeader } from "../../../utilities/FUNCTIONS";
import { getMonthWiseM2DReport, exportReport } from './monthWiseM2DReportActions'


const MonthWiseM2DReport = (props) => {
    const userRights = JSON.parse(storage.get('_userRights'));
    const [target, setTarget] = useState(null);
    const [show, setShow] = useState(false);
    const ref = useRef(null);
    // pagination states
    const [currentIndex, setCurrentIndex] = useState();
    const [currentPageNo, setCurrentPageNo] = useState(0);
    const [currentPageSize, setCurrentPageSize] = useState(5);
    const [searchText, setSearchText] = useState('');
    const [totalRecords, setTotalRecords] = useState(0);
    const [distributorList, setDistributorList] = useState([]);
    const [distCenterList, setDistCenterList] = useState([]);
    const [deliverymanNameList, setDeliverymanNameList] = useState([]);
    const [isApplyFilter, setIsApplyFilter] = useState(false);

    const [filter, setfilter] = useState({
        distributor: null,
        distCenter: null,
        deliverymanName: null,
        fromMonth: new Date(),
        toMonth: new Date(),
        pageNo: 0,
        searchText: null,
        isExport: false,
    })

    const openFilterModal = (event) => {
        setShow(!show)
        setTarget(event.target)
    }

    function commonReset(reset = true) {
        if (reset) {
            setSearchText('');

            setfilter({
                distributor:
                    userRights != null && userRights?.userType == 'DistributorUser'
                        ? filter.distributor
                        : null,
                distCenter: null,
                deliverymanName: null,
                fromMonth: new Date(),
                toMonth: new Date(),
                pageNo: 0,
                searchText: null,
                isExport: false,
            })
        }
    }

    function formRequestObject(isExport = false) {
        let requestData = {
            distributor: filter.distributor?.value,
            distCenter: filter.distCenter?.value,
            deliverymanName: filter.deliverymanName?.value,
            mfi: filter.mfi?.value,
            fromDate: filter.fromMonth && formatDate(filter.fromMonth),
            toDate: filter.toMonth && formatDate(filter.toMonth),
            pageSize: currentPageSize,
            pageNo: currentPageNo,
            searchText: searchText,
            isExport: isExport,
        }
        if (userRights != null && (userRights?.userType == 'DistributorUser' || userRights?.userType == 'CoreAppUser')) {
            requestData = {
                ...requestData,
                distributorId: userRights?.distributorId,
            }
        }
        return requestData
    }

    function fetchReportData(request) {
        let finalRequest = request == null ? formRequestObject() : request
        props.getMonthWiseM2DReport(finalRequest)
    }

    const handleResetFilters = (resetForm) => {
        resetForm()
        commonReset()
    }

    const getData = (page) => {
        setCurrentPageNo(page)
        var request = { ...formRequestObject(), pageNo: page }
        fetchReportData(request)
    }

    const pageSizeChanged = (pageSize) => {
        setCurrentPageNo(0)
        setCurrentPageSize(pageSize)
        var request = { ...formRequestObject(), pageSize: pageSize }
        fetchReportData(request)
    }

    const searchChanged = (text) => {
        setSearchText(text)
    }

    const LoadDataByfilter = (event) => {
        setCurrentPageNo(0)
        var request = { ...formRequestObject(), pageNo: 0 }
        fetchReportData(request)
        setShow(false)
        setIsApplyFilter(true)
    }

    const Download = () => {
        let request = formRequestObject(true)
        props.exportReport(request)
    }

    useEffect(() => {
        setCurrentPageNo(0)
        fetchReportData()
    }, [searchText])

    useEffect(() => {
        if (props.report && props.report.totalRecords > 0) {
            setTotalRecords(props.report.totalRecords)
        } else {
            setTotalRecords(0)
        }
    }, [props.report])

    useEffect(() => {
        if (userRights != null && userRights?.userType == 'DistributorUser') {
            let distributorList = props.allDistributorList.filter(
                (x) => x.value == userRights?.distributorId
            )
            if (distributorList?.length > 0) {
                setfilter({
                    ...filter,
                    distributor: {
                        label: distributorList[0]?.label,
                        value: distributorList[0]?.value,
                    },
                })
            }
            setDistributorList(
                distributorList.map(function (item) {
                    return {
                        value: item.value,
                        label: item.label,
                    }
                })
            )
        } else if (userRights != null && userRights?.userType == "CoreAppUser") {
            let distributorList = props.allDistributorList.filter((x) =>
                userRights?.distributorId.includes(x.value)
            );
            setDistributorList(
                distributorList.map(function (item) {
                return {
                    value: item.value,
                    label: item.label,
                };
                })
            );
            } else {
            setDistributorList(
                props.allDistributorList.map(function (item) {
                    return {
                        value: item.value,
                        label: item.label,
                    }
                })
            )
        }
    }, [props.allDistributorList])

    useEffect(() => {
        if (userRights != null && (userRights?.userType == 'DistributorUser' || userRights?.userType == 'CoreAppUser')) {
            let distCenterList = props.selectedDistCentersList.filter((x) =>
                userRights?.distCenterIds.includes(x.value)
            )
            setDistCenterList(
                distCenterList.map(function (item) {
                    return {
                        value: item.value,
                        label: item.label,
                    }
                })
            )
        } else {
            setDistCenterList(
                props.selectedDistCentersList.map(function (item) {
                    return {
                        value: item.value,
                        label: item.label,
                    }
                })
            )
        }
    }, [props.selectedDistCentersList])

    useEffect(() => {
        if (props.deliverymanTills) {
            setDeliverymanNameList(
                props.deliverymanTills.map(function (item) {
                    return {
                        value: item.qrCode,
                        label: item.fullname,
                    }
                })
            )
        }

    }, [props.deliverymanTills])

    useEffect(() => {
        props.getDropdownList(
            `api/Distributor/GetDistributorsDDL`,
            GET_DISTRIBUTOR_DDL
        )
    }, [])

    useEffect(() => {
        if (filter.distributor) {
            props.getDropdownListByPost(
                `api/DistCenter/GetDistCentersDDL`,
                {distributorIds: filter.distributor.value},
                GET_DISTRIBUTIONCENTER_DDL
            )
        }
        filter.distCenter = null
        filter.deliverymanName = null
    }, [filter.distributor])

    useEffect(() => {
        if (filter.distCenter) {
            props.getDropdownList(
                `api/DistCenter/GetCenterDeliveryUserDDL/${filter.distCenter.value}`,
                GET_DELIVERYMAN_TILL_DDL
            )
        }
        filter.deliverymanName = null
    }, [filter.distCenter])

      useEffect(() => {
        props.getDropdownList(
          `api/ShopOrderTransaction/GetOnlyM2DPaymentTypes`,
          GET_PAYMENT_TYPES_DDL
        );
      }, []);

    const columns = [
        {
            Header: 'Dist Center',
            accessor: 'distcenter',
        },
        {
            Header: 'Deliveryman Name',
            accessor: 'deliverymanName',
        },
        {
            Header: 'Month',
            accessor: 'month',
        },
        {
            Header: renderHeader('Unique Shops Invoices'),
            accessor: 'uniqueShopsInvoices',
           Cell: ({ value }) => renderCell(value, true),
        },
        {
            Header: renderHeader('Unique Shops Transacted'),
            accessor: 'uniqueShopstransacted',
           Cell: ({ value }) => renderCell(value, true),
        },
        {
            Header: renderHeader('No of Transactions'),
            accessor: 'noOfTansactions',
           Cell: ({ value }) => renderCell(value, true),
        },
        {
            Header: renderHeader('% of Active Shops (Against Invoice)'),
            accessor: 'percentageOfActiveShops',
            Cell: ({ value }) => renderCell(value, true),
        },
        {
            Header: renderHeader('Invoices Amount'),
            accessor: 'invoicesAmount',
           Cell: ({ value }) => renderCell(value, true),
        },
        {
            Header: renderHeader('Updated Amount'),
            accessor: 'updatedInvoiceAmount',
           Cell: ({ value }) => renderCell(value, true),
        },
        {
            Header: renderHeader('M2D Amount'),
            accessor: 'm2DAmount',
            Cell: ({ value }) => renderCell(value, true),
        },
        {
            Header: renderHeader('M2D %'),
            accessor: 'm2DPercentage',
             Cell: ({ value }) => renderCell(value, true),
        },
    ]

    return (
        <div>
            <VzPageContainer title='Month-Wise M2D Report'>
                <Row>
                    <Col style={{ float: 'left' }}>
                        <h4>
                            <b>Month-Wise M2D Report</b>
                        </h4>
                        <br />
                    </Col>
                </Row>
                <Row>
                    <Col md={10} style={{ float: 'right' }}>
                        <div ref={ref}>
                            <Button
                                onClick={openFilterModal}
                                className='m-3'
                                variant='outline-primary'
                            >
                                <i className='fa fa-filter' />
                                Filters
                            </Button>

                            <Overlay
                                show={show}
                                target={target}
                                placement='bottom'
                                container={ref}
                                containerPadding={20}
                                width='430px'
                                style={{ width: '430px' }}
                            >
                                <Popover
                                    id='popover-contained'
                                    style={{ maxWidth: '360px', width: '300px' }}
                                >
                                    <Popover.Header as='h3'>Filters</Popover.Header>
                                    <Popover.Body>
                                        <Formik
                                            enableReinitialize
                                            initialValues={filter}
                                            validator={() => ({})}
                                            onSubmit={LoadDataByfilter}
                                        >
                                            {(formik) => (
                                                <Form autoComplete='off'>
                                                    <Row>
                                                         {(userRights == null || userRights?.userType == 'CoreAppUser') && (
                                                            <Col xs={12} md={12}>
                                                                <FormikControl
                                                                    formik={formik}
                                                                    control='react-select'
                                                                    label='Distributor Name'
                                                                    name='distributor'
                                                                    options={distributorList}
                                                                    isClearable={true}
                                                                    isSearchable={true}
                                                                    handleOnChange={(e) => {
                                                                        if (!e || !e.value) {
                                                                            setfilter({
                                                                                ...filter,
                                                                                distributor: null,
                                                                            })
                                                                            return
                                                                        }
                                                                        setfilter({
                                                                            ...filter,
                                                                            distributor: {
                                                                                label: e.label,
                                                                                value: e.value,
                                                                            },
                                                                        })
                                                                    }}
                                                                    value={filter.distributor}
                                                                />
                                                            </Col>
                                                        )}

                                                        <Col xs={12} md={12}>
                                                            <FormikControl
                                                                formik={formik}
                                                                control='react-select'
                                                                label='Distribution Center'
                                                                name='distCenter'
                                                                options={filter.distributor != null ? distCenterList : []}
                                                                isClearable={true}
                                                                isSearchable={true}
                                                                handleOnChange={(e) => {
                                                                    if (!e || !e.value) {
                                                                        setfilter({
                                                                            ...filter,
                                                                            distCenter: null,
                                                                        })
                                                                        return
                                                                    }
                                                                    setfilter({
                                                                        ...filter,
                                                                        distCenter: {
                                                                            label: e.label,
                                                                            value: e.value,
                                                                        },
                                                                    })
                                                                }}
                                                                value={filter.distCenter}
                                                            />
                                                        </Col>
                                                        <Col xs={12} md={12}>
                                                            <FormikControl
                                                                formik={formik}
                                                                control='react-select'
                                                                label='Deliveryman Name'
                                                                name='deliverymanName'
                                                                options={filter.distCenter != null ? deliverymanNameList : []}
                                                                isClearable={true}
                                                                isSearchable={true}
                                                                handleOnChange={(e) => {
                                                                    if (!e || !e.value) {
                                                                        setfilter({
                                                                            ...filter,
                                                                            deliverymanName: null,
                                                                        })
                                                                        return
                                                                    }
                                                                    setfilter({
                                                                        ...filter,
                                                                        deliverymanName: {
                                                                            label: e.label,
                                                                            value: e.value,
                                                                        },
                                                                    })
                                                                }}
                                                                value={filter.deliverymanName}
                                                            />
                                                        </Col>
                                                        <Col xs={12} md={12}>
                                                                                      <FormikControl
                                                                                        formik={formik}
                                                                                        control="react-select"
                                                                                        label="Payment Type"
                                                                                        name="mfi"
                                                                                        options={props.paymentTypeList
                                                                                                  .map((x) => ({
                                                                                                    ...x,
                                                                                                    label: x.label.toLowerCase() === "onebill" ? "1Bill" : x.label,
                                                                                                  }))}
                                                                                        isClearable={true}
                                                                                        handleOnChange={(option) => {
                                                                                          filter.mfi = option;
                                                                                        }}
                                                                                        value={filter.mfi}
                                                                                      />
                                                                                    </Col>
                                                                                    
                                                        <Row style={{ paddingRight: 0 }}>
                                                            <Col xs={12} md={6}>
                                                                <FormikControl
                                                                    control='date'
                                                                    label='From Date'
                                                                    name='fromDate'
                                                                    handleOnChange={(value) => {
                                                                        setfilter({ ...filter, fromMonth: value })
                                                                    }}
                                                                    value={filter.fromMonth}
                                                                />
                                                            </Col>
                                                            <Col xs={12} md={6}>
                                                                <FormikControl
                                                                    control='date'
                                                                    label='To Date'
                                                                    name='fromDate'
                                                                    handleOnChange={(value) => {
                                                                        setfilter({ ...filter, toMonth: value })
                                                                    }}
                                                                    value={filter.toMonth}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </Row>
                                                    <div className='row' style={{ marginTop: 20 }}>
                                                        <div className='form-group'>
                                                            <Link
                                                                onClick={handleResetFilters.bind(
                                                                    null,
                                                                    formik.resetForm,
                                                                    setIsApplyFilter(false)
                                                                )}
                                                                to='#'
                                                                className='active'
                                                                style={{
                                                                    padding: '0px',
                                                                    marginTop: '10px',
                                                                    float: 'left',
                                                                }}
                                                            >
                                                                Reset
                                                            </Link>
                                                            <Link
                                                                onClick={() => {
                                                                    setShow(false)
                                                                    setTarget(null)
                                                                    commonReset(isApplyFilter)
                                                                }}
                                                                to='#'
                                                                className='active'
                                                                style={{
                                                                    padding: '0px',
                                                                    marginTop: '10px',
                                                                    float: 'right',
                                                                }}
                                                            >
                                                                Cancel
                                                            </Link>
                                                            <div className='float-right'>
                                                                <Button
                                                                    type='submit'
                                                                    className='btn btn-primary'
                                                                    style={{
                                                                        marginRight: '10px',
                                                                        float: 'right',
                                                                    }}
                                                                >
                                                                    Apply
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Form>
                                            )}
                                        </Formik>
                                    </Popover.Body>
                                </Popover>
                            </Overlay>
                        </div>
                    </Col>
                    {isPermittedPage('Export', props.actions, props.userRole) &&
                        <Col md={2} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Button
                                onClick={Download}
                                className='m-3'
                                variant='outline-primary'
                            >
                                <i className='fa fa-download me-1' />
                                Export
                            </Button>
                        </Col>
                    }
                </Row>
                <Row>
                    <Col>
                        <ServerSideDataTable
                            data={props.report?.data ?? []}
                            columns={columns}
                            getTrProps={(event, data) => null}
                            goToPreviousPage={(val) => getData(val)}
                            goToNextPage={(val) => getData(val)}
                            totalRecords={totalRecords}
                            pageSizeChange={(size) => pageSizeChanged(size)}
                            myPageSize={currentPageSize}
                            myIndex={currentIndex}
                            pageNo={currentPageNo}
                            searchChanged={searchChanged}
                        />
                    </Col>
                </Row>
            </VzPageContainer>
        </div >
    )
}

const mapStateToProps = (state) => {
    return {
        report: state.MonthWiseM2DRport,
        allDistributorList: state.ddlList.allDistributorList
            ? state.ddlList.allDistributorList
            : [],
        selectedDistCentersList: state.ddlList.selectedDistCentersList
            ? state.ddlList.selectedDistCentersList
            : [],
        deliverymanTills: state.ddlList.deliverymanTills
            ? state.ddlList.deliverymanTills
            : [],
        paymentTypeList: state.ddlList.paymentTypeList,
    }
}

export default connect(mapStateToProps, {
    getMonthWiseM2DReport,
    getDropdownList,
    getDropdownListByPost,
    exportReport,
})(MonthWiseM2DReport)
